import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {/* About */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              ELL'ZEN
            </h3>
            <p className="text-white/90 text-xs md:text-sm leading-relaxed">
              Votre destination pour des <strong>produits de beauté</strong> de qualité au Luxembourg
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Liens rapides
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/90 hover:text-white text-xs md:text-sm transition-colors cursor-pointer">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/produits" className="text-white/90 hover:text-white text-xs md:text-sm transition-colors cursor-pointer">
                  Produits
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/90 hover:text-white text-xs md:text-sm transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Catégories
            </h3>
            <ul className="space-y-2">
              <li className="text-white/90 text-xs md:text-sm">Parfums</li>
              <li className="text-white/90 text-xs md:text-sm">Corps et Hygiène</li>
              <li className="text-white/90 text-xs md:text-sm">Soins du Visage</li>
              <li className="text-white/90 text-xs md:text-sm">Soins Capillaires</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Contact
            </h3>
            <ul className="space-y-2">
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-base md:text-lg mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span className="text-white/90 text-xs md:text-sm">+352 621 812 568</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-base md:text-lg mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span className="text-white/90 text-xs md:text-sm break-all">ellzen.lux@gmail.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-base md:text-lg mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span className="text-white/90 text-xs md:text-sm">Luxembourg</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-6 md:mt-8 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/80 text-xs md:text-sm text-center sm:text-left">
            © 2025 ELL'ZEN. Tous droits réservés.
          </p>
          <a 
            href="https://www.ellzenskincare.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/80 hover:text-white text-xs md:text-sm transition-colors cursor-pointer"
          >
            WOW (WhatsApp Order Website) powered by Wazi Consulting
          </a>
        </div>
      </div>
    </footer>
  );
};
